import {getter} from "../../utlis/store/store-utils";

export default class Translate {
  recipeCategoryList = [];
  tagList = [];
  productList = [];
  workModeList = [];
  supportLangList = [];
  vm = null; // vue实例

  // 转换后的数据
  data = {};


  fields = [
    "name",
    "foodDescription",
    "introduction",
    "chefRec",
    "cookingStepList",
    "foods",
    "nutritionList",
    "category"
  ]

   constructor(vm) {
    this.vm = vm;
    this.supportLangList = vm.$store.getters.supportLang;
    this.handleGetDataListByAll().then(() => {
      console.log('加载所需数据完成');
    });
  }

  async handleGetDataListByAll() {
    const promiseList = [
      {key: 'recipeCategoryList', prom: getter("recipeCategoryList")},
      {key: 'tagList', prom: getter("tagList")},
      {key: 'productList', prom:  getter("productList")},
      {key: 'workModeList', prom:  getter("workModeList")},
    ];
    const res = await Promise.all(promiseList.map(item => item.prom));
    promiseList.forEach((item, index) => {
      this[item.key]= res[index];
    })
  }


  /**
   * 由食谱数据格式转换为翻译数据格式
   * @param recipe 食谱原始结构数据
   * @return {{nutritionList: (*&{value: *})[], restTime: string, foods: (*&{value: *})[], difficultyLevel: *, supportLangList: string, type: *, tags: string, products: string, makeTime: string, cookingStepList: {workModeName: *, value: *}[], foodDescription: (string|*), prepareTime: string, chefRec: (string|*), name, lang: *, category: *, portionSize: *, introduction: (string|*)}}
   */
  transformTranslateData(recipe = {}) {
    if(!Object.keys(recipe).length) {
      throw new Error('Recipe data is empty');
    }
    const {
      lang,
      supportLangList,
      type,
      recipeCategoryCode,
      cookingStepList,
      prepareHours,
      prepareMinutes,
      makeHours,
      makeMinutes,
      restHours,
      restMinutes,
      difficultyLevel,
      recipeLang,
      portionSizeList,
      nutritionList,
      tags,
      products
    } = recipe;

    // 当前主语言的表单
    const mainLangForm = recipeLang[lang];

    // 份量
    const portionSizeItem = portionSizeList[0] || {portionSize: {}, foods: []};

    const formData = {
      // 不可编辑
      supportLangList: this.supportLangList.filter(item => supportLangList.includes(item.value))
        .map(item => item.name).join("，"), // 支持语言
      lang:  this.supportLangList.find(item => item.value === lang)?.name, // 主语言
      type: type ? this.vm.$t(`lang.${this.vm.$dict.RECIPE_TYPE[type]}`) : null, // 类型
      prepareTime: `${prepareHours || 0} h ${prepareMinutes || 0} min`, // 准备时间
      makeTime: `${makeHours || 0} h ${makeMinutes || 0} min`, // 制作时间
      restTime: `${restHours || 0} h ${restMinutes || 0} min`, // 休息时间
      portionSize: portionSizeItem.portionSize[lang], // 份量
      difficultyLevel: difficultyLevel ? this.vm.$t(`lang.${this.vm.$dict.DIFFICULTY_LEVEL[difficultyLevel]}`) : '', // 难易水平
      tags: this.tagList.filter(item => tags.includes(item.recipeTagCode))
        .map(item => item.name).join("，"), // 标签列表
      products: this.productList.filter(item => products.includes(item.productCode))
        .map(item => item.productModel).join("，"), // 兼容型号


      // 可编辑
      name: mainLangForm?.name, // 名称
      category: this.recipeCategoryList.find(item => item.recipeCategoryCode === recipeCategoryCode)?.name, // 分类
      foodDescription: mainLangForm?.foodDescription, // 食材描述
      introduction: mainLangForm?.introduction, // 做法介绍
      chefRec: mainLangForm?.chefRec, // 厨师建议
      cookingStepList: cookingStepList.map(item => {
        return {
          value: item.stepLang[lang],
          workModeName: this.workModeList.find(f => f.value === item.workMode)?.name,
        }
      }), // 步骤
      foods: portionSizeItem.foods.map(item => {
        return {
          ...item[lang],
          value: item[lang].foodName,
        }
      }), // 食材
      nutritionList: nutritionList.map(item => {
        return {...item[lang], value: item[lang].nutritionName}
      }), // 营养成分
    };
    this.data = formData;
    return formData;
  }


  /**
   * 构建翻译表单
   */
  buildTranslateForm() {
    // 获取编辑字段内容
    const translateData = [];
    const data = this.data;
    for (const key in data) {
      if(!this.fields.includes(key)) continue;
      if(typeof data[key] === "string") {
        if(data[key]) translateData.push({id: key, value: data[key]});
        continue;
      }

      // 处理数组
      if(Array.isArray(data[key])) {
        data[key].forEach((item, index) => {
          if(item.value) {
            translateData.push({id: key + '_' + index, value: item.value});
          }
        })
      }
    }
    return translateData;
  }

  /**
   * 由翻译表单结构转回食谱结构
   * @param translateData 翻译表单结构数据
   * @param recipeData 食谱原始数据
   * @param lang 语言
   * @return {any}
   */
  buildRecipeForm(translateData, recipeData, lang) {
    recipeData = JSON.parse(JSON.stringify(recipeData));
    const {cookingStepList, recipeLang, portionSizeList, nutritionList} = recipeData;
    const {
      name,
      foodDescription,
      introduction,
      chefRec,
      cookingStepList: cookingStepListByT,
      foods,
      nutritionList: nutritionListByT,
    } = translateData

    console.log('translateData', translateData);

    // 处理 名称、食材描述、做法介绍、厨师建议
    if(!recipeLang[lang]) recipeLang[lang] = {};
    recipeLang[lang] = {
      name,
      foodDescription,
      introduction,
      chefRec
    }

    // 处理食材
    if(portionSizeList.length) {
      portionSizeList[0].foods.forEach((item, index) => {
        if(!item[lang]) item[lang] = {};
        item[lang] = {...foods[index], foodName: foods[index].value};
        delete item[lang].value;
      })

      // 同步食材份量
      const portionSize = portionSizeList[0].portionSize;
      for (const key in portionSize) {
        if(portionSize[key]) continue;
        portionSize[key] = translateData.portionSize;
      }

      if(!portionSize[lang]) {
        portionSize[lang] = translateData.portionSize;
      }
      portionSizeList[0].portionSize = portionSize;
    }

    // 处理做法步骤
    cookingStepList.forEach((item, index) => {
      if(!item.stepLang[lang]) item.stepLang[lang] = {};
      item.stepLang[lang] = cookingStepListByT[index].value;
    })

    // 处理营养成分
    nutritionList.forEach((item, index) => {
      if(!item[lang]) item[lang] = {};
      item[lang] = {...nutritionListByT[index], nutritionName: nutritionListByT[index].value};
      delete item[lang].value;
    })

    // 判断一下支持语言中是否有，没有则添加
    if(!recipeData.supportLangList.includes(lang)) recipeData.supportLangList.push(lang);

    return Object.assign({}, recipeData, {recipeLang});
  }


  // 翻译回来的数据set进翻译表单结构中
  setTranslateData(translateData, recipeData) {
    const translateMap = {};
    translateData.forEach(item =>  {
      translateMap[item.id] = Array.isArray(item.value) ? item.value[0] : null;
    })


    for (const key in recipeData) {
      if(!this.fields.includes(key)) continue;
      if(typeof recipeData[key] === "string") {
        recipeData[key] = translateMap[key];
      } else if(Array.isArray(recipeData[key])) {
        recipeData[key].forEach((item, index) => {
          item.value = translateMap[key + "_" + index];
        })
      }
    }
    return recipeData;
  }

}

